import React from 'react';
import {  TouchableOpacity, TouchableWithoutFeedback, View, StyleSheet, TouchableNativeFeedback} from "react-native";
import {Text} from "./../UI-Components"
// import Icon from 'react-native-vector-icons/dist/Ionicons';
import Icon from '@material-ui/core/Icon';
import KeyboardArrowRightIcon from '@material-ui/icons/KeyboardArrowRight';



const buttonComponent = (props) => {
    const {
        style,
        title,
        To,
        Tb,
        textStyle,
        onPress, icon,
        iconStyle,
        size,
        bold
    } = props;
    const Touchable = To ? TouchableOpacity : Tb ? TouchableNativeFeedback : TouchableWithoutFeedback
    return(
        <Touchable
        onPress={onPress}
        >
            <View
            {...props}
            style={style}
            >
                <Text style={{...textStyle}} bold={bold}>
                    {title}
                </Text>
                {
                    // icon &&  <Icon
                    // name={icon}
                    // size={size}
                    // style={iconStyle}
                    // />
                    icon &&  icon === 'keyboard_arrow_right'
                     ?
                    <KeyboardArrowRightIcon style={{...iconStyle}}/>
                    :
                    <Icon
                    style={iconStyle}
                    >{icon}</Icon> 
                }               
            </View>
        </Touchable>
    )
}

const styles = StyleSheet.create({
    button: {
        justifyContent:'center',
        alignItems:'center',
        borderRadius:10,
    }
})

export default buttonComponent;